var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "178",
        height: "136",
        viewBox: "0 0 178 136",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M0.00439453 136H177.148V0H0.00439453V136Z",
          fill: "#96DE06",
        },
      }),
      _c("path", {
        attrs: { d: "M177.148 136H0.00439453V0L177.148 136Z", fill: "#C6FB31" },
      }),
      _c("path", {
        attrs: { d: "M0 73.4785V136H81.4353L0 73.4785Z", fill: "#96DE06" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }